import React, { useState, useEffect } from "react";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faTrashCan } from "@fortawesome/free-solid-svg-icons";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  IconLookup,
  IconDefinition,
  findIconDefinition,
} from "@fortawesome/fontawesome-svg-core";
import countriesDropdownValues from "../Utils/CountriesUN";
import DropDMultiple from "./InputComponents/DropDMultiple";
import CardHeader from "./Utils/CardHeaderComponent";
import TextConfidential from "./InputComponents/TextConfidentialComponent";
import DropdownNumberMandatory from "./InputComponents/DropdownNumberMandatoryComponent";
import DropdownStringMandatory from "./InputComponents/DropdownStringMandatoryComponent";
import ConfirmationModal from "./Utils/ConfirmationModal";
import EditableTitle from "./InputComponents/EditableTitle";
import Tooltip from "./InputComponents/Tooltip";

library.add(faTrashCan);
const trashLookup: IconLookup = { prefix: "fas", iconName: "trash-can" };
const trashcanDefinition: IconDefinition = findIconDefinition(trashLookup);
library.add(faAngleRight);
const angleLookup: IconLookup = { prefix: "fas", iconName: "angle-right" };
const angleDefinition: IconDefinition = findIconDefinition(angleLookup);

interface BrandOwnerProps {
  errors: string[];
  data: {
    // #### SET 1 ###
    bioBasedProductMarketEnhancement: string;

    brandOwnersPicList: string;

    numberOfBrandOwners: number;
    numberOfBrandOwnersText: string;
    numberOfBrandOwnersSensitive: boolean;
  };
  
  tAndP : 
    {
      table : string;
      property :string;
      tooltip : string;
      placeholder : string;
      id : string;
    }[];
  picNumbers: string[];
  handleOnChangeBrandOwner: (
    e?: React.ChangeEvent<any>,
    dropDown?: {
      name: string;
      value: string[];
    }
  ) => void;
  status: number;

  handleDeleteBrandOwner: () => void;
  customLabelValues : {
    table : string;
    property: string;
    value: string;
    id :string;
  }[];
  handleUpdateEditableTitle : (id : string, value: string)=>void;
}

function BrandOwner({
  data,
  handleOnChangeBrandOwner,
  handleDeleteBrandOwner,
  status,
  picNumbers,
  errors,
  customLabelValues,
  handleUpdateEditableTitle,
  tAndP
}: BrandOwnerProps) {
  const [isHidden, setIsHidden] = useState(true);
  const toggleVisibility = () => {
    setIsHidden((prevState) => !prevState);
  };
  const numberOfBrandOwnersTextIsValid = /^.{4,}$/.test(
    data.numberOfBrandOwnersText
  );
  const [isModalOpen, setIsModalOpen] = useState(false);
  const handleDeleteClick = () => {
    setIsModalOpen(true);
  };
  const confirmDelete = () => {
    setIsModalOpen(false);
    handleDeleteBrandOwner();
  };
  const cancelDelete = () => {
    setIsModalOpen(false);
  };

  return (
    <div className="feedstock-container">
      <CardHeader
        isHidden={isHidden}
        toggleVisibility={toggleVisibility}
        cardName="Brand Owner"
        handleDelete={status == 1 ? handleDeleteClick : null}
        notValid={errors.length > 0}
      />
      <div className={isHidden ? "hidden-content" : "visible-content"}>
        <div className="form-container">
          <div className="error-container">
            {errors.map((error, index) => (
              <div
                className="error-text"
                key={index}
                style={{ marginBottom: "10px" }}
              >
                {error}
              </div>
            ))}
          </div>
          <div className="questions-wrapper">
          <div className="row">
            <div className="col-12">
              
            <Tooltip content={tAndP.find(item => item.property == "CBE JU KPI 7")?.tooltip}>
              <div className="question-text">
                CBE JU KPI 7  🛈 <br />
                
                
                <EditableTitle 
                    customLabelValue={customLabelValues.find(item => item.property == "bioBasedProductMarketEnhancement")} 
                    handleUpdateEditableTitle={handleUpdateEditableTitle}/>
              </div>
              </Tooltip>
              <DropdownStringMandatory
                listInputs={[
                  "-",
                  "Yes - Beneficiary",
                  "Yes - Engaged with other mechanisms",
                  "No",
                ]}
                label={""}
                inputName={"bioBasedProductMarketEnhancement"}
                value={data.bioBasedProductMarketEnhancement}
                handleOnChange={handleOnChangeBrandOwner}
                invalidValues={["", "-"]}
              />
            </div>
          </div>
          <div
            className={
              data.bioBasedProductMarketEnhancement == "Yes - Beneficiary"
                ? "visible-content"
                : "hidden-content"
            }
          >
            <div className="row">
              <div className="col-12">
                <DropdownStringMandatory
                  listInputs={picNumbers}
                  label={"Please select the brand owner"}
                  inputName={"brandOwnersPicList"}
                  value={data.brandOwnersPicList}
                  handleOnChange={handleOnChangeBrandOwner}
                  invalidValues={["", "-"]}
                />
              </div>
              {/* <div className="col-md-6 col-sm-12">
                <div
                  className={
                    data.brandOwnersPicList == 0
                      ? "hidden-content"
                      : "visible-content"
                  }
                >
                  <TextConfidential
                    label={"please specify the mechanism "}
                    textValid={brandOwnersPicListTextIsValid}
                    textValue={data.brandOwnersPicListText}
                    textName={"numberOfBrandOwnersText"}
                    onChange={handleOnChangeBrandOwner}
                    isConfidential={data.brandOwnersPicListSensitive}
                    confidentialInputName={"brandOwnersPicListSensitive"}
                    display={false}
                  />
                </div> 
              </div>*/}
            </div>
          </div>

          <div
            className={
              data.bioBasedProductMarketEnhancement ==
              "Yes - Engaged with other mechanisms"
                ? "visible-content"
                : "hidden-content"
            }
          >
            <div className="row">
              {/* <div className="col-md-6 col-sm-12">
                <div className="form-group">
                  <label className="control-label">
                    Number of brand owners engaged with other mechanisms
                  </label>
                  <select
                    name="numberOfBrandOwners"
                    className={
                      data.numberOfBrandOwners == -1
                        ? "form-control is-invalid"
                        : "form-control"
                    }
                    value={data.numberOfBrandOwners}
                    onChange={handleOnChangeBrandOwner}
                  >
                    {twentyOptions.map((option) => (
                      <option
                        key={option.value == "-" ? -1 : option.value}
                        value={option.value == "-" ? -1 : option.value}
                      >
                        {option.value}
                      </option>
                    ))}
                  </select>
                </div>
              </div> */}
              <div className="col-md-12">
                <TextConfidential
                  label={"Please specify the mechanism "}
                  textValid={data.numberOfBrandOwnersText.length > 4}
                  textValue={data.numberOfBrandOwnersText}
                  textName={"numberOfBrandOwnersText"}
                  onChange={handleOnChangeBrandOwner}
                  isConfidential={data.numberOfBrandOwnersSensitive}
                  confidentialInputName={"numberOfBrandOwnersSensitive"}
                  display={false}
                />
              </div>
            </div>
          </div>
          </div>
        </div>
      </div>
      <ConfirmationModal
        isOpen={isModalOpen}
        onRequestClose={cancelDelete}
        onConfirm={confirmDelete}
        title="
        Confirm deletion"
        message="Are you sure you want to delete this component ?"
      />
    </div>
  );
}
const twentyOptions = Array.from({ length: 20 }, (_, i) => ({
  value: i.toString(),
}));

export default BrandOwner;
